const RICOS_VERSION = "10.129.1";
export {
  RICOS_VERSION
};
//# sourceMappingURL=version.js.map
